import { Box, Package, Truck } from "lucide-react";
import { ServiceType } from "./constants";
import { HTMLProps, ElementType, FC } from "react";
import { cn } from ".";

const getIcons = (
  Icon: ElementType,
  className: string
): FC<HTMLProps<SVGSVGElement>> => {
  return ({ size, className: _className, ...props }) => (
    <Icon size={size ?? 16} className={cn(className, _className)} {...props} />
  );
};

export const serviceIcons = {
  [ServiceType.COLLECTION]: { icon: getIcons(Truck, "text-blue-600") },
  [ServiceType.DELIVERY]: { icon: getIcons(Truck, "text-green-600") },
  [ServiceType.ON_SITE_SERVICE]: { icon: getIcons(Package, "text-purple-600") },
  [ServiceType.WAREHOUSE_SERVICE]: { icon: getIcons(Box, "text-amber-600") },
  [ServiceType.FABRICATION_SERVICE]: {
    icon: getIcons(Package, "text-red-600"),
  },
};
